<template>
  <li class="items-center pr-2 lg:pr-4 hidden lg:inline-flex">
    <div class="inline-block h-8 w-px bg-semantic-inverse-on-surface" />
  </li>
</template>

<script setup>
defineOptions({
  name: 'V2AtomsMenuDivider'
})
</script>
